import { useEffect, useState } from 'react';
import { useAuth } from './AuthProvider';

export function AuthCallback() {
  const { session, loading, configured } = useAuth();
  const [error, setError] = useState('');

  useEffect(() => {
    const search = new URLSearchParams(window.location.search);
    const hash = new URLSearchParams(window.location.hash.replace(/^#/, ''));
    const description =
      search.get('error_description') ||
      search.get('error') ||
      hash.get('error_description') ||
      hash.get('error');
    if (description) setError(description.replace(/\+/g, ' '));
  }, []);

  useEffect(() => {
    if (session) window.location.replace('/');
  }, [session]);

  return (
    <main className="shell flex min-h-screen items-center justify-center">
      <div className="rounded-3xl border border-slate-200 bg-white p-8 text-center shadow-xl">
        <h1 className="text-2xl font-semibold text-slate-900">
          {error ? 'Google sign-in did not finish' : 'Signing you in…'}
        </h1>
        <p className="mt-2 text-slate-600">
          {error || (configured && loading ? 'Please wait a moment.' : 'Connecting your Google account.')}
        </p>
        <a className="button button-primary mt-6 inline-flex" href="/">
          Back to Phrasio
        </a>
      </div>
    </main>
  );
}
